module.exports = __webpack_public_path__ + "prod/1.42.2/img/chunsheng.367b2067.jpg";